import React, { useState } from 'react';
import FourOpinionsExercise from './FourOpinionsExercise';
import './FourOpinionsExerciseBoard.css';

const FOUR_OPINIONS_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%)', marginRight: 20
  }}>
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  </span>
);

const FourOpinionsExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { opinions, title, level } = exerciseData;

  if (!opinions || !Array.isArray(opinions)) {
    return (
      <div className="four-opinions-board-error">
        <p>Error: Invalid Four Opinions exercise data</p>
      </div>
    );
  }

  return (
    <div className="four-opinions-exercise-board">
      {!isExpanded ? (
        <div
          className={`four-opinions-preview unified-exercise-preview fo-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {FOUR_OPINIONS_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">Four Opinions</div>
            <div className="unified-preview-meta">
              {opinions.length} opinions · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="four-opinions-expanded">
          <FourOpinionsExercise
            opinions={opinions}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            updateAttributes={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default FourOpinionsExerciseBoard;
